import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { TabType } from '../types';

export const DEFAULT_TAB = TabType.PROFILE;

export const useActiveTab = (mode: 'create' | 'edit') => {
  const [searchParams, setSearchParams] = useSearchParams();
  const currentTab = searchParams.get('tab') as TabType;

  // Initialize tab if not set
  useEffect(() => {
    if (!currentTab) {
      setSearchParams({ tab: DEFAULT_TAB });
    }
  }, [currentTab, setSearchParams]);

  // Filter out delivery zones tab in create mode
  const availableTabs =
    mode === 'create'
      ? Object.values(TabType).filter((tab) => tab !== TabType.DELIVERY_ZONES)
      : Object.values(TabType);

  const setActiveTab = (tab: TabType) => {
    if (availableTabs.includes(tab)) {
      setSearchParams({ tab });
    }
  };

  return {
    activeTab: currentTab || DEFAULT_TAB,
    setActiveTab,
    availableTabs,
  };
};
